import { IComponentController } from 'angular';

export class LoadingWrapperController implements IComponentController {
    public isLoading!: boolean;
    public hasContent!: boolean;
}
